var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 left-0 w-full h-screen flex items-center justify-center z-50 bg-realBlack"},[_c('img',{staticClass:"md:w-auto w-[130px]",attrs:{"src":require("@/assets/images/whiteLogo.png"),"alt":"Logo"}})])
}]

export { render, staticRenderFns }